/** The circle page query parameter naming a tab: `/circle/<id>?tab=360`. */
export const TAB_QUERY_PARAM = 'tab';

/**
 * The index of the tab a deep link asks for, by label: the same tab sits at a
 * different index in the member and leader views. `null` when the address
 * names no tab or the circle has no tab with that label (then the page opens
 * as it always has).
 */
export const requestedTabIndex = (
  search: string,
  labels: readonly string[]
): number | null => {
  const label = new URLSearchParams(search).get(TAB_QUERY_PARAM);
  if (!label) {
    return null;
  }
  const index = labels.indexOf(label);
  return index >= 0 ? index : null;
};
